<!--suppress TypeScriptUnresolvedVariable -->
<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>

<form class="po-pdf">
    <div class="header">{{headerText}}</div>

    <div class="intro">
        <span class="intro-regular">{{introRegularText1}} {{introRegularText2}}</span>
    </div>

    <div class="parties" [innerHTML]="partiesTextHTML"></div>

    <div class="po-info">
        <table>
            <tr><th *ngFor="let column of columns" [style.width]="column.widthPercent + '%'" [style.textAlign]="'center'">{{column.title}}</th></tr>

            <tr class="bordered-row">
                <td [style.width]="columns[0].widthPercent + '%'" [style.textAlign]="'center'" rowspan="2">{{poManager.current.number}}</td>
                <td [style.width]="columns[1].widthPercent + '%'" [style.textAlign]="'center'">Converters</td>
                <td [style.width]="columns[2].widthPercent + '%'" [style.textAlign]="'center'">{{poManager.current.totalNumConverters}}</td>
                <td [style.width]="columns[3].widthPercent + '%'" [style.textAlign]="'center'">{{poManager.current.totalConvertersPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[4].widthPercent + '%'" [style.whiteSpace]="'nowrap'" [style.textAlign]="'center'" rowspan="2">{{poManager.current.totalPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[5].widthPercent + '%'" [style.textAlign]="'center'" >                            
                    <p-inputNumber [inputStyle]="{'width': '100px', 'backgroundColor': 'white', 'border': '1px solid gray'}" [(ngModel)]="poManager.current.catsAdjustment" (ngModelChange)="poManager.adjustmentChange()" inputId="currency-us" mode="currency" [currency]="userCurrency" locale="en-US" [ngModelOptions]="{standalone: true}" />
                </td>
                <td style="width: 15%; text-align: center; white-space: nowrap; padding: 0 10px" rowspan="2">{{poManager.current.totalAdjusted | currency:poManager.current.currency:true}}</td>
            </tr>
            <tr class="bordered-row">
                <!-- <td [style.width]="columns[0].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.number}}</td> -->
                <td [style.width]="columns[1].widthPercent + '%'" [style.text-align]="'center'">Non-Ferrous</td>
                <td [style.width]="columns[2].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.numMiscellaneous}}</td>
                <td [style.width]="columns[3].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.totalMiscPrice | currency:poManager.current.currency:true}}</td>
                <td [style.width]="columns[5].widthPercent + '%'" [style.textAlign]="'center'" >                            
                    <p-inputNumber [inputStyle]="{'width': '100px', 'backgroundColor': 'white', 'border': '1px solid gray'}" [(ngModel)]="poManager.current.nonFerrousAdjustment" (ngModelChange)="poManager.adjustmentChange()" inputId="currency-us" mode="currency" [currency]="userCurrency" locale="en-US" [ngModelOptions]="{standalone: true}" />
                </td>
                <!-- <td [style.width]="columns[4].widthPercent + '%'" [style.text-align]="'center'">{{poManager.current.adjustment | currency:poManager.current.currency:true}}</td> -->
            </tr>
        </table>
    </div>

    <ls-payment-types-selection [(selectedPaymentTypes)]="selectedPaymentTypes" [allowedCashAmount]="allowedCashPayment" />
    <div *ngIf="selectedPaymentTypes.includes(PurchaseOrderPaymentType.Cash)" class="po-info cash-payment-type">
        <table>
            <tr class="bordered-row">
                <td>{{allowedCashPaymentText}}</td>
                <td>{{allowedCashPayment | currency:poManager.current.currency:true}}</td>
            </tr>
            <tr class="bordered-row">
                <td>{{remainingCheckOrWirePaymentText}}</td>
                <td>{{remainingNonCashPayment | currency:poManager.current.currency:true}}</td>
            </tr>
        </table>
        <div class="cash-payment-law-text">
            <div>{{cashPaymentLawText1}}</div>
            <div>{{cashPaymentLawText2}}</div>
        </div>
    </div>

    <div class="seller-info">
        <div>{{sellerInfoHeaderText}}</div>
        <div style="display: flex; flex-direction: row; align-items: center; gap: 8px;">
            <p-dropdown [options]="poManager.current.vendor.contacts" [(ngModel)]="selectedContact" [ngModelOptions]="{standalone: true}"
                        optionLabel="fullName" placeholder="Select Contact" (onChange)="onSelectedContactChanged()"></p-dropdown>
            <span style="color: red; font-size: .9rem" *ngIf="selectedContact != null && !selectedContact.isContactValidForPO">Contact data is incomplete</span>
        </div>
        <div class="multiple-fields">
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(idText)}}</span>
                    <input type="text" pInputText [disabled]="true" [(ngModel)]="idNum" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(stateText)}}</span>
                    <input type="text" pInputText [disabled]="true" [(ngModel)]="idState" [ngModelOptions]="{standalone: true}"/>
                </div>
            </div>
        </div>
    </div>

    <ls-vehicle-info [selectedContact]="selectedContact"/>
    <div class="signature-section">

        <div>{{signaturePrelude}}</div>
        <div class="signature-prelude-warning">{{signaturePreludeWarning}}</div>

        <div class="multi-signature-line tall signature">
            <div class="text">{{removeUnderscores(signatureText)}}</div>
            <div class="signature-auto-expand"><ls-capture-signature #signature></ls-capture-signature></div>
        </div>

        <div class="multiple-fields name-and-date">
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(printText)}}</span><input type="text" pInputText [(ngModel)]="poManager.current.print" [ngModelOptions]="{standalone: true}" class="name"/>
                </div>
            </div>
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>{{removeUnderscores(dateText)}}</span>
                    <p-calendar [(ngModel)]="poManager.current.purchaseDate" [showTime]="true" [ngModelOptions]="{standalone: true}" [styleClass]="ThemeManager.theme" appendTo="body" inputStyleClass="calendar-input-style"></p-calendar>
                </div>
            </div>
            <div class="field-group">
                <div class="p-inputgroup">
                    <span>Time Zone</span>
                    <p-dropdown [options]="timeZones" [(ngModel)]="selectedTimezone" [ngModelOptions]="{standalone: true}"
                        optionLabel="fullName" placeholder="Select Timezone"></p-dropdown>
                </div>
            </div>
        </div>
    </div>

    <div class="buttons">
        <div class="buttons-left">
            <p-button severity="secondary" (click)="clearSignatures()">Clear Signatures</p-button>
        </div>
        <div class="buttons-right">
            <p-button severity="secondary" (click)="onCancel()">Cancel</p-button>
            <p-button (click)="onSave()" [disabled]="selectedTimezone == null || !poManager.current.totalsValid || signature.isEmpty || poManager.current.print?.length === 0 || selectedPaymentTypes.length === 0 ||
                      (remainingNonCashPayment> 0 && !selectedPaymentTypes.includes(PurchaseOrderPaymentType.Check) &&
                !selectedPaymentTypes.includes(PurchaseOrderPaymentType.WireTransfer))" >Confirm
            </p-button>
        </div>
    </div>
</form>
